<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Bienvenido{{usuario}}</h1>
      </v-subheader>
    </v-container>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Bienvenido",
  data: () => ({
    usuario: ""
  }),
  computed: {
    ...mapGetters(["getToken"])
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    async loadUsuario() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + `/api/usuario/obtener?username=`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      let usuario = respuesta.data.username;

      this.usuario = usuario ? ", " + usuario : "";
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  created() {
    this.loadUsuario();
  }
};
</script>


<style>
</style>